import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GROUP_INSERT_GQL,
  GET_GROUP_GQL,
  GET_GROUP_LIST_GQL,
  GET_GROUP_LIST_GQL2,
  GET_MY_GROUP_GQL,
  GROUP_UPDATE_GQL,
  GET_USER_MIN_INFO_GQL,
  GET_GROUP_INFO_GQL,
  GROUP_DELETE_GQL,
  GET_TEAM_TO_USERS_GQL,
  GET_USER_GROUP_CATEGORIES_GQL,
  GET_GROUP_FROM_SLUG_GQL,
} from '@/graphql/queries.gql';

const initTeam = {
  id: '',
  groupName: '',
  slug: '',
  color: '#cccccc',
  icon: '',
};

export default {
  namespaced: true,

  state: {
    // = data
    globalGroup: localStorage.getItem('globalGroupId'),
    groups: [],
    groupList: [],
    groupList_allTeam: [],
    myGroups: [],
    insertGroup: null,
    editGroup: null,
    // setGroupToUser: null,
    getMyUserGroups: [],
    teamInfo: Object.assign({}, initTeam),
    removedGroup: null,
    myTeamList: [],
    myTeamList2: [],
    addTeamPerm: false,
    editTeamPerm: false,
    editUserperm: false,
    groupCategories: [],
    userCompanyId: null,
    teamFromSlug: null,
  },

  mutations: {
    SET_GROUPS(state, payload) {
      state.groups = payload;
    },
    GET_MY_GROUPS(state, payload) {
      state.myGroups = payload;
    },
    GET_MY_TEAMS(state, payload) {
      state.myTeamList = payload;
    },
    GET_MY_TEAMS2(state, payload) {
      state.myTeamList2 = payload;
    },
    SET_GROUP_INSERT(state, payload) {
      state.insertGroup = payload;
    },

    SET_GROUP_EDIT(state, payload) {
      state.editGroup = payload;
    },
    GET_GROUP_LIST(state, payload) {
      state.groupList = payload;
    },
    UPDATE_GROUP_TEAM(state, payload) {
      const teamDetails = state.myTeamList.find(group => group.id === payload.id);
    },
    SET_GLOBAL_GROUP(state, payload) {
      state.globalGroup = payload.globalGroupId;
    },
    GET_GROUP_INFO_BUDGET(state, payload) {
      state.groupBudgetInfo = payload;
    },
    SET_GROUP_BUDGET_INSERT(state, payload) {
      state.groupBudgetCreated = payload;
    },
    SET_GROUP_BUDGET_UPDATE(state, payload) {
      state.groupBudgetUpdated = payload;
    },
    // SET_GROUP_TO_USER(state, payload) {
    //   state.setGroupToUser = payload;
    // },
    GET_GROUP_LIST_ALLTEAM(state, payload) {
      state.groupList_allTeam = payload;
    },
    GET_MY_USER_GROUPS(state, payload) {
      state.getMyUserGroups = payload;
    },
    SET_GROUP_INFO(state, payload) {
      state.teamInfo = payload;
    },
    SET_GROUP_DELETE(state, payload) {
      state.removedGroup = payload;
    },
    SET_ADD_TEAM_PERM(state, payload) {
      state.addTeamPerm = payload;
    },
    SET_EDIT_TEAM_PERM(state, payload) {
      state.editTeamPerm = payload;
    },
    SET_EDIT_USER_PERM(state, payload) {
      state.editUserperm = payload;
    },
    SET_CATEGORY_FOR_GROUP(state, payload) {
      state.groupCategories = payload;
    },
    // SET_USER_COMPANY_ID(state, payload) {
    //   state.userCompanyId = payload;
    // },
    GET_TEAM_FROM_SLUG(state, payload) {
      state.teamFromSlug = payload;
    },
  },

  actions: {
    // = methods
    // destructuring `context.commit` by doing `{ commit }`
    getGroups({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_GROUP_GQL,
          variables: {
            id: payload.groupId,
          },
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          commit('SET_GROUPS', data.group);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    myGroupList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_MY_GROUP_GQL,
          variables: payload,
          // fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          commit('GET_MY_GROUPS', data.groups);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getGroupList({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_GROUP_LIST_GQL,
          fetchPolicy: 'network-only',
          variables: payload,
        })
        .then(({ data }) => {
          commit('GET_GROUP_LIST', data.groups);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    myGroupPermList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      let flag = 0;
      let teamInfo = [];
      payload.id.forEach((permission) => {
        const i = [];

        permission.permissions.forEach((id) => {
          i.push(id.id);
        });
        if (permission.team.slug === 'all-teams') {
          flag = 1;
          permission.permissions.forEach((perm) => {
            if (perm.slug === 'create_team') {
              commit('SET_ADD_TEAM_PERM', true);
            }
          });
        } else {
          teamInfo.push(permission.team);
        }
        permission.permissions = i;
      });
      if (flag === 1) {
        apolloClient
          .query({
            query: GET_GROUP_LIST_GQL,
            variables: {
              recordStatus: 1,
              flag: 1,
              companyId: payload.companyId,
            },
            fetchPolicy: 'no-cache',
          })
          .then(({ data }) => {
            teamInfo = data.groups;
            console.log(teamInfo);

            commit('GET_MY_TEAMS', teamInfo);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          })
          .catch((err) => {
            console.log(err);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          });
      } else {
        console.log(teamInfo);
        commit('GET_MY_TEAMS', teamInfo);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      }
    },
    myCategoryPermList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_USER_MIN_INFO_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          const flag = 0;
          const teamInfo = [];
          const categoryBudgetList = [];
          data.user.teams.forEach((permission) => {
            const i = [];
            permission.team.slug = permission.team.groupName.replace(/\s+/g, '-').toLowerCase();
            permission.permissions.forEach((id) => {
              i.push(id.id);
            });
            apolloClient
              .query({
                query: GET_USER_GROUP_CATEGORIES_GQL,
                variables: payload,
              })
              .then(({ data }) => {
                data.groups[0].categories.forEach((category) => {
                  let totalBudget = 0;
                  const categoryList = {};
                  categoryList.id = category.id;
                  categoryList.categoryName = category.categoryName;
                  category.categorybudgets.forEach((ctbudget) => {
                    totalBudget += ctbudget.amount;
                  });
                  categoryList.amount = totalBudget;
                  categoryList.groupbudget = data.groups[0].groupbudgets[0].amount;
                  categoryBudgetList.push(categoryList);
                });
                categoryBudgetList.amount = data.groups[0].groupbudgets[0].amount;
                categoryBudgetList.groupId = data.groups[0].id;
              });


            teamInfo.push(permission.team);

            permission.permissions = i;
          });
          if (flag === 1) {
            apolloClient
              .query({
                query: GET_ALL_GROUP_CATEGORIES_GQL,
                variables: payload,
              })
              .then(({ data }) => {
                const categoryBudgetList = [];
                data.groups[0].categories.forEach((category) => {
                  let totalBudget = 0;
                  const categoryList = {};
                  categoryList.id = category.id;
                  categoryList.categoryName = category.categoryName;
                  category.categorybudgets.forEach((ctbudget) => {
                    totalBudget += ctbudget.amount;
                  });
                  categoryList.amount = totalBudget;
                  categoryList.groupbudget = data.groups[0].groupbudgets[0].amount;
                  categoryBudgetList.push(categoryList);
                });
                categoryBudgetList.amount = data.groups[0].groupbudgets[0].amount;
                categoryBudgetList.groupId = data.groups[0].id;

                commit('SET_CATEGORY_FOR_GROUP', categoryBudgetList);
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              });
          } else {
            commit('SET_CATEGORY_FOR_GROUP', categoryBudgetList);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    myGroupPermList2({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      let flag = 0;
      let teamInfo = [];
      payload.id.forEach((permission) => {
        if (permission.team.slug === 'all-teams') {
          flag = 1;
        } else {
          teamInfo.push(permission.team);
        }
      });
      if (flag === 1) {
        apolloClient
          .query({
            query: GET_GROUP_LIST_GQL2,
            variables: {
              recordStatus: 1,
              flag: 2,
              companyId: payload.companyId,
            },
            fetchPolicy: 'network-only',
          })
          .then(({ data }) => {
            teamInfo = data.groups.sort((a, b) => a.groupName.localeCompare(b.groupName));
            const allTeamInfIndex = teamInfo.findIndex((team) => team.slug === 'all-teams');
            if(allTeamInfIndex >= 0) {
              const allTeamObj = teamInfo[allTeamInfIndex];
              teamInfo.splice(allTeamInfIndex,1);
              teamInfo.unshift(allTeamObj);
            }
            commit('GET_MY_TEAMS2', teamInfo);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          })
          .catch((err) => {
            console.log(err);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          });
      } else {
        teamInfo = teamInfo.sort((a, b) => a.groupName.localeCompare(b.groupName));
        const allTeamInfIndex = teamInfo.findIndex((team) => team.slug === 'all-teams');
        if(allTeamInfIndex >= 0) {
          const allTeamObj = teamInfo[allTeamInfIndex];
          teamInfo.splice(allTeamInfIndex,1);
          teamInfo.unshift(allTeamObj);
        }
        commit('GET_MY_TEAMS2', teamInfo);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      }
    },
    getGroupInfo({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_GROUP_INFO_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_GROUP_INFO', data.group);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    getGroupInfoWithPerm({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_GROUP_INFO_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          apolloClient
            .query({
              query: GET_TEAM_TO_USERS_GQL,
              variables: {
                recordStatus: 1,
                userId: payload.userId,
              },
            })
            .then(({ data }) => {
              data.teamToUsers.forEach((permission) => {
                permission.permissions.forEach((id) => {
                  if (id.slug === 'edit_team' && (permission.team.id === payload.id || permission.team.groupName === 'All Teams')) {
                    commit('SET_EDIT_TEAM_PERM', true);
                  }
                });
              });
            });

          commit('SET_GROUP_INFO', data.group);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    getTeamPermInfo({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_TEAM_TO_USERS_GQL,
          variables: {
            recordStatus: 1,
            userId: payload.userId,
            teamId: payload.teamId,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          data.teamToUsers.forEach((permission) => {
            permission.permissions.forEach((id) => {
              if (id.slug === 'edit_team') {
                commit('SET_EDIT_TEAM_PERM', true);
              }
            });
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    resetTeam({ commit }) {
      commit('SET_GROUP_INFO', Object.assign({}, initTeam));
    },
    groupInsert({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .mutate({
          mutation: GROUP_INSERT_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_GROUP_INSERT', data.groupInsert);

          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    globalGroupUpdate({ commit }, payload) {
      localStorage.setItem('globalGroupId', payload.globalGroupId);
      commit('SET_GLOBAL_GROUP', payload);
    },
    updateGroup({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: GROUP_UPDATE_GQL,
          variables: {
            groupId: payload.id,
            groupName: payload.groupName,
            author: payload.author,
            icon: payload.icon,
            color: payload.color,
            templateTeam: payload.templateTeam,
            templateCategory: payload.templateCategory,
          },
        })
        .then(({ data }) => {
          commit('SET_GROUP_EDIT', data.updateGroup);
          commit('UPDATE_GROUP_TEAM', data.updateGroup);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    removeGroup({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: GROUP_DELETE_GQL,
          variables: {
            groupId: payload.id,
            recordStatus: payload.recordStatus,
            author: payload.author,
          },
        })
        .then(({ data }) => {
          commit('SET_GROUP_DELETE', data.updateGroup);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getGroupFromSlug({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_GROUP_FROM_SLUG_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_TEAM_FROM_SLUG', data.groups);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },


  },

  getters: {
    // = computed properties
    groups: state => state.groups,
    insertGroup: state => state.insertGroup,
    globalGroup: state => state.globalGroup,
    groupList: state => state.groupList,
    myGroups: state => state.myGroups,
    editGroup: state => state.editGroup,
    // setGroupToUser: state => state.setGroupToUser,
    groupList_allTeam: state => state.groupList_allTeam,
    getMyUserGroups: state => state.getMyUserGroups,
    teamInfo: state => state.teamInfo,
    removedGroup: state => state.removedGroup,
    myTeamList: state => state.myTeamList,
    myTeamList2: state => state.myTeamList2,
    addTeamPerm: state => state.addTeamPerm,
    editTeamPerm: state => state.editTeamPerm,
    addUserperm: state => state.addUserperm,
    editUserperm: state => state.editUserperm,
    groupCategories: state => state.groupCategories,
    userCompanyId: state => state.userCompanyId,
    teamFromSlug: state => state.teamFromSlug,
  },
};
